<template lang="pug">
  .component.component-backoffice-note(v-if="item")
    .card( v-if="$is('listing')")
      .inner-content
        cardN(:showBullets="true", :showAction="true", :columns="2")
          div(slot="actionBullets")
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              CityButtons(:item="item")
          .field-value(slot="n1") C{{item.id}}
          .label(slot="n2") Name
          .field-value(slot="n2") {{item.name}}
</template>
<script type="text/babel">
  import CardN from 'components/structure/CardN'
  import Dropdown from '../structure/foundation/Dropdown'
  import TocButtons from '../structure/ui/actions/TocButtons'
  import TocTypeButtons from '../structure/ui/actions/TocTypeButtons'
  import CommonCostButtons from '../structure/ui/actions/CommonCostButtons'
  import CityButtons from "../structure/ui/actions/CityButtons.vue";

  export default {
    name: 'City',
    components: {
      CityButtons,
      CommonCostButtons,
      TocTypeButtons,
      TocButtons,
      Dropdown,
      CardN,
    },
    data() {
      return {}
    },
    created() {
    },
    methods: {},
    computed: {},
    props: {
      item: Object,
      type: {
        type: String,
        default: ''
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// City.vue?c8a0234a